<template>
  <div class="landing-page-content">
    <div class="img-wrapper">
      <img src="../../theme/img/logo.png" alt="fresh-garden" class="logo" />
    </div>
    <div class="content-wrapper">
      <span class="download-title">{{ $t('messages.download') }}</span>
      <div class="download-content-img">
        <a
          class="source-apps"
          target="_blank"
          href="https://play.google.com/store/apps/details?id=al.inovacion.ecommerce.fastfresh&hl=en_US"
        >
          <img
            src="../../assets/img/google_play.png"
            class="apps-img"
            alt="download freshgarden android"
          />
        </a>
        <a
          class="source-apps"
          href="https://apps.apple.com/us/app/fresh-garden-albania/id1420966664"
          target="_blank"
        >
          <img
            src="../../assets/img/app_store.png"
            class="apps-img"
            alt="download freshgarden android"
          />
        </a>
      </div>
    </div>
    <div class="bottom-footer-mobile">
      <span class="footer-text">
        © Fresh Garden {{ new Date().getFullYear() }} - All Rights
        Reserved</span
      >
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

Component({})
export default class Mobile extends Vue {}
</script>
